const languagePack = {
  fr: {
    Map: 'Carte',
    'Central Topic': 'Sujet central',
    'Main Topic': 'Sujet principal',
  },
  de: {
    Map: 'Map',
    'Central Topic': 'Hauptthema',
    'Main Topic': 'Hauptknoten',
  },
  vi: {
    Map: 'Bản đồ',
    'Central Topic': 'Chủ đề trung tâm',
    'Main Topic': 'Chủ đề chính',
  },
  'zh-TW': {
    Map: '圖面',
    'Central Topic': '中心主題',
    'Main Topic': '主要主題',
  },
  'zh-CN': {
    Map: '画布',
    'Central Topic': '中心主题',
    'Main Topic': '分支主题',
  },
  'ja-JP': {
    Map: 'マップ',
    'Central Topic': '中心トピック',
    'Main Topic': 'メイントピック',
  },
  ru: {
    Map: 'Карта',
    'Central Topic': 'Центральная тема',
    'Main Topic': 'Основная тема',
  },
  ko: {
    Map: '지도',
    'Central Topic': '중심 주제',
    'Main Topic': '주요 주제',
  },
}

const translateCreator = (lang: string) => (key: string) => languagePack?.[lang]?.[key] ?? key

export const getContentJSON = (lang = 'en-US') => {
  const $T = translateCreator(lang)

  return [
    {
      id: '34e508c5-955b-4ab0-93a2-94036e5eccd9',
      revisionId: 'fa0d7f69-a3ae-4a11-8378-356fe1c06ab8',
      class: 'sheet',
      rootTopic: {
        id: 'd826bd09-484b-4771-8c00-abb2f84a3710',
        class: 'topic',
        title: $T('Central Topic'),
        titleUnedited: true,
        children: {
          attached: [
            {
              id: 'e5e4de71-34e4-4709-ab36-d24316a75eb2',
              title: `${$T('Main Topic')} 1`,
              titleUnedited: true,
            },
            {
              id: 'c21cd9dd-d3a4-4bcb-80e1-54c69d4c8b26',
              title: `${$T('Main Topic')} 2`,
              titleUnedited: true,
            },
            {
              id: 'bfb3e6b1-28ad-4412-927f-8da15e4fecae',
              title: `${$T('Main Topic')} 3`,
              titleUnedited: true,
            },
            {
              id: 'e4764559-bd6e-4427-86a7-d08492ddcd2a',
              title: `${$T('Main Topic')} 4`,
              titleUnedited: true,
            },
          ],
        },
      },
      title: `${$T('Map')} 1`,
      topicOverlapping: 'overlap',
      extensions: [
        {
          provider: 'org.xmind.ui.skeleton.structure.style',
          content: {
            centralTopic: 'org.xmind.ui.map.clockwise',
            mainTopic: 'org.xmind.ui.logic.right',
          },
        },
      ],
      theme: {
        centralTopic: {
          id: '476bc75c-bf5c-4703-9df1-13a4d21ee3a9',
          properties: {
            'fo:font-family': 'NeverMind',
            'fo:font-size': '30pt',
            'fo:font-weight': '800',
            'fo:font-style': 'normal',
            'fo:color': 'inherited',
            'fo:text-transform': 'manual',
            'fo:text-decoration': 'none',
            'fo:text-align': 'center',
            'svg:fill': '#000000',
            'fill-pattern': 'none',
            'line-width': '2pt',
            'line-color': '#ADADAD',
            'line-pattern': 'solid',
            'border-line-color': '#000000',
            'border-line-width': '0pt',
            'border-line-pattern': 'inherited',
            'shape-class': 'org.xmind.topicShape.roundedRect',
            'line-class': 'org.xmind.branchConnection.curve',
            'arrow-end-class': 'org.xmind.arrowShape.none',
            'alignment-by-level': 'inherited',
          },
        },
        mainTopic: {
          id: '33d94ac6-933b-461f-82b4-c780a7b11af7',
          properties: {
            'fo:font-family': 'NeverMind',
            'fo:font-size': '18pt',
            'fo:font-weight': '500',
            'fo:font-style': 'normal',
            'fo:color': 'inherited',
            'fo:text-transform': 'manual',
            'fo:text-decoration': 'none',
            'fo:text-align': 'left',
            'svg:fill': 'inherited',
            'fill-pattern': 'solid',
            'line-width': '2pt',
            'line-color': 'inherited',
            'line-pattern': 'inherited',
            'border-line-color': 'inherited',
            'border-line-width': '0pt',
            'border-line-pattern': 'inherited',
            'shape-class': 'org.xmind.topicShape.roundedRect',
            'line-class': 'org.xmind.branchConnection.roundedElbow',
            'arrow-end-class': 'inherited',
            'alignment-by-level': 'inherited',
          },
        },
        subTopic: {
          id: '391970a7-5563-486b-ba9c-b9a4aa91c937',
          properties: {
            'fo:font-family': 'NeverMind',
            'fo:font-size': '14pt',
            'fo:font-weight': '400',
            'fo:font-style': 'normal',
            'fo:color': 'inherited',
            'fo:text-transform': 'manual',
            'fo:text-decoration': 'none',
            'fo:text-align': 'left',
            'svg:fill': 'inherited',
            'fill-pattern': 'none',
            'line-width': '2pt',
            'line-color': 'inherited',
            'line-pattern': 'inherited',
            'border-line-color': 'inherited',
            'border-line-width': '0pt',
            'border-line-pattern': 'inherited',
            'shape-class': 'org.xmind.topicShape.roundedRect',
            'line-class': 'org.xmind.branchConnection.roundedElbow',
            'arrow-end-class': 'inherited',
            'alignment-by-level': 'inherited',
          },
        },
        floatingTopic: {
          id: 'b4b447de-487e-4ce5-aec0-60766c8da981',
          properties: {
            'fo:font-family': 'NeverMind',
            'fo:font-size': '14pt',
            'fo:font-weight': '500',
            'fo:font-style': 'normal',
            'fo:color': 'inherited',
            'fo:text-transform': 'manual',
            'fo:text-decoration': 'none',
            'fo:text-align': 'left',
            'svg:fill': '#EEEBEE',
            'fill-pattern': 'solid',
            'line-width': '2pt',
            'line-color': 'inherited',
            'line-pattern': 'solid',
            'border-line-color': '#EEEBEE',
            'border-line-width': '0pt',
            'border-line-pattern': 'inherited',
            'shape-class': 'org.xmind.topicShape.roundedRect',
            'line-class': 'org.xmind.branchConnection.roundedElbow',
            'arrow-end-class': 'org.xmind.arrowShape.none',
            'alignment-by-level': 'inherited',
          },
        },
        summaryTopic: {
          id: 'e449dad5-38cf-4084-ac2e-e47040992cf6',
          properties: {
            'fo:font-family': 'NeverMind',
            'fo:font-size': '14pt',
            'fo:font-weight': '400',
            'fo:font-style': 'normal',
            'fo:color': 'inherited',
            'fo:text-transform': 'manual',
            'fo:text-decoration': 'none',
            'fo:text-align': 'left',
            'svg:fill': '#000000',
            'fill-pattern': 'none',
            'line-width': 'inherited',
            'line-color': 'inherited',
            'line-pattern': 'inherited',
            'border-line-color': '#000000',
            'border-line-width': 'inherited',
            'border-line-pattern': 'inherited',
            'shape-class': 'org.xmind.topicShape.roundedRect',
            'line-class': 'org.xmind.branchConnection.roundedElbow',
            'arrow-end-class': 'inherited',
            'alignment-by-level': 'inherited',
          },
        },
        calloutTopic: {
          id: '43283c7c-08ed-46bc-a056-fbf77ffedc60',
          properties: {
            'fo:font-family': 'NeverMind',
            'fo:font-size': '14pt',
            'fo:font-weight': '400',
            'fo:font-style': 'normal',
            'fo:color': 'inherited',
            'fo:text-transform': 'manual',
            'fo:text-decoration': 'none',
            'fo:text-align': 'left',
            'svg:fill': '#000000',
            'fill-pattern': 'solid',
            'line-width': 'inherited',
            'line-color': 'inherited',
            'line-pattern': 'inherited',
            'border-line-color': '#000000',
            'border-line-width': 'inherited',
            'border-line-pattern': 'inherited',
            'shape-class': 'org.xmind.topicShape.roundedRect',
            'line-class': 'org.xmind.branchConnection.roundedElbow',
            'arrow-end-class': 'inherited',
            'alignment-by-level': 'inherited',
          },
        },
        level3: {
          id: '63c31e0e-5a84-4e8a-b68a-d54ca7f0d9fd',
          properties: {
            'fo:font-family': 'NeverMind',
            'fo:font-size': '14pt',
            'fo:font-weight': '400',
            'fo:font-style': 'normal',
            'fo:text-transform': 'manual',
            'fo:text-decoration': 'none',
            'fo:text-align': 'left',
            'fill-pattern': 'solid',
            'line-width': '2pt',
            'line-pattern': 'inherited',
            'border-line-width': '0pt',
            'border-line-pattern': 'inherited',
            'shape-class': 'org.xmind.topicShape.roundedRect',
            'line-class': 'org.xmind.branchConnection.roundedElbow',
            'arrow-end-class': 'inherited',
            'alignment-by-level': 'inherited',
          },
        },
        importantTopic: {
          id: '18e7cdaf-f868-44f3-9bf8-23fd4cce47e3',
          properties: {
            'fo:font-weight': 'bold',
            'svg:fill': '#7F00AC',
            'fill-pattern': 'solid',
            'border-line-color': '#7F00AC',
            'border-line-width': '0',
          },
        },
        minorTopic: {
          id: 'a466de7d-7c83-43e7-8146-34bf81f8b3bf',
          properties: {
            'fo:font-weight': 'bold',
            'svg:fill': '#82004A',
            'fill-pattern': 'solid',
            'border-line-color': '#82004A',
            'border-line-width': '0',
          },
        },
        expiredTopic: {
          id: '0fbe0949-6710-47ff-9bbc-89f1888d7458',
          properties: {
            'fo:text-decoration': 'line-through',
            'fill-pattern': 'none',
          },
        },
        summary: {
          id: 'e7636eaf-d14b-4c41-bdc8-22239171388f',
          properties: {
            'line-width': '2pt',
            'line-color': '#000000',
            'line-pattern': 'solid',
            'shape-class': 'org.xmind.summaryShape.round',
          },
        },
        boundary: {
          id: '5e5ea36f-8318-4f2f-b41b-88effcbf93b2',
          properties: {
            'fo:font-family': 'NeverMind',
            'fo:font-size': '14pt',
            'fo:font-weight': '400',
            'fo:font-style': 'normal',
            'fo:color': 'inherited',
            'fo:text-transform': 'manual',
            'fo:text-decoration': 'none',
            'fo:text-align': 'center',
            'svg:fill': '#9B9B9B',
            'fill-pattern': 'solid',
            'line-width': '2',
            'line-color': '#00000066',
            'line-pattern': 'dash',
            'shape-class': 'org.xmind.boundaryShape.roundedRect',
          },
        },
        relationship: {
          id: '002077a9-9a90-4bbc-89c1-a587d2115ba0',
          properties: {
            'fo:font-family': 'NeverMind',
            'fo:font-size': '13pt',
            'fo:font-weight': '400',
            'fo:font-style': 'normal',
            'fo:color': 'inherited',
            'fo:text-transform': 'manual',
            'fo:text-decoration': 'none',
            'fo:text-align': 'center',
            'line-width': '2',
            'line-color': '#00000066',
            'line-pattern': 'dash',
            'shape-class': 'org.xmind.relationshipShape.curved',
            'arrow-begin-class': 'org.xmind.arrowShape.none',
            'arrow-end-class': 'org.xmind.arrowShape.triangle',
          },
        },
        map: {
          id: '405c637d-5f65-49bd-b19f-497183429efd',
          properties: {
            'svg:fill': '#ffffff',
            'multi-line-colors': '#FF6B6B #FF9F69 #97D3B6 #88E2D7 #6FD0F9 #E18BEE',
            'color-list': '#FF6B6B #FF9F69 #97D3B6 #88E2D7 #6FD0F9 #E18BEE',
            'line-tapered': 'none',
          },
        },
        skeletonThemeId: '8f137afe-a0f3-4f25-b56a-cfd05993ef4b',
        colorThemeId: 'Dawn-#ffffff-MULTI_LINE_COLORS',
      },
    },
  ]
}
